import { createEvoClient, isEligibleForTrial } from "@jti/evo-client";
import type { TssApiContract } from "@jti/rest-api-types";

export class TssApiEvo implements TssApiContract {
  private readonly client;
  constructor(baseUrl: string, tenantToken: string, ciamToken: string, recaptchaId: string) {
    this.client = createEvoClient({
      baseUrl: baseUrl,
      tenantToken,
      recaptchaId,
      ciamToken,
      throwOnError: true,
    });
  }

  async getEligibility({ categoryId, userId }: { categoryId: string; userId: string }): Promise<boolean> {
    try {
      const { data } = await isEligibleForTrial({
        client: this.client,
        path: {
          consumer: userId,
          program: categoryId,
        },
      });

      return Boolean(data?.is_eligible);
    } catch {
      return false;
    }
  }
}
